import { CommonModule } from '@angular/common';
import { Component, ElementRef, Input, OnChanges, OnDestroy, OnInit, forwardRef } from '@angular/core';
import { LanguageService } from '@core/service/language.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { TranslationDialogComponent } from '@shared/components/translation/translation-dialog.component';
import { Subject } from 'rxjs';
import { HasAnyAccessDirective } from './has-any-access.directive';

@Component({
  standalone: true,
  selector: '[tmwTranslate]',
  template: `@if (render) {
      <span [innerHTML]="tmwTranslate | translate: translateValues"></span>
    }
    @if (service.isEdit() | async) {
      <span *hasAnyAccess="'EDIT_TRANSLATION'; module: 'MDL_GENERAL'" class="inline-link">
        <a (click)="edit($event); (false)">
          <i class="bi bi-translate"></i>
        </a>
      </span>
    } `,
  styles: [
    `
      .tmwTranslate {
        color: #868e96;
        font-size: 14px;
        margin-left: 5px;
      }
    `,
  ],
  imports: [CommonModule, TranslateModule, forwardRef(() => HasAnyAccessDirective)],
})
export class TmwTranslateDirective implements OnChanges, OnInit, OnDestroy {
  @Input() tmwTranslate!: string;
  @Input() translateValues?: { [key: string]: unknown };

  @Input() render: boolean = true;

  private readonly directiveDestroyed = new Subject();

  constructor(
    private el: ElementRef,
    protected service: LanguageService,
    private modalService: NgbModal
  ) {}

  ngOnInit(): void {}

  ngOnChanges(): void {
    // this.getTranslation();
  }

  ngOnDestroy(): void {
    this.directiveDestroyed.next(null);
    this.directiveDestroyed.complete();
  }

  edit(e: any) {
    e.stopPropagation();

    const modalRef = this.modalService.open(TranslationDialogComponent, {
      size: 'lg',
      backdrop: 'static',
      windowClass: 'modal show',
    });
    modalRef.componentInstance.translation = { code: this.tmwTranslate };
  }
}
